var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 3.7785C5.94496 3.7785 3.33329 6.46135 3.33329 9.77081C3.33329 13.0803 5.94496 15.7631 9.16663 15.7631C12.3883 15.7631 15 13.0803 15 9.77081C15 6.46135 12.3883 3.7785 9.16663 3.7785ZM1.66663 9.77081C1.66663 5.51578 5.02449 2.06641 9.16663 2.06641C13.3088 2.06641 16.6666 5.51578 16.6666 9.77081C16.6666 14.0258 13.3088 17.4752 9.16663 17.4752C5.02449 17.4752 1.66663 14.0258 1.66663 9.77081Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2857 14.0021C13.6111 13.6678 14.1388 13.6678 14.4642 14.0021L18.0892 17.7259C18.4147 18.0602 18.4147 18.6023 18.0892 18.9366C17.7638 19.2709 17.2361 19.2709 16.9107 18.9366L13.2857 15.2128C12.9603 14.8785 12.9603 14.3364 13.2857 14.0021Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.f596abe7d0a1e7db0418b9a4090742a5.svg";
export { ForwardRef as ReactComponent };